/**
 * Top-page motion gate.
 * GSAP is fetched after the initial render so the section overlap works on all viewports.
 */
const REDUCE_QUERY = "(prefers-reduced-motion: reduce)";
const config = window.nmHomeMotionConfig || {};

let motionRequested = false;

const loadHomeMotion = () => {
    const scriptUrl = String(config.desktopScriptUrl || "");
    if (motionRequested || window.matchMedia(REDUCE_QUERY).matches || !scriptUrl) return;

    motionRequested = true;
    requestAnimationFrame(() => {
        const load = () => {
            const script = document.createElement("script");
            script.src = scriptUrl;
            script.defer = true;
            document.body.appendChild(script);
        };

        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(load, { timeout: 1800 });
        } else {
            window.setTimeout(load, 0);
        }
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadHomeMotion, { once: true });
} else {
    loadHomeMotion();
}
